import React from 'react'
import { InstallationsContextProps } from '../types'

export const InstallationsContext = React.createContext<InstallationsContextProps | undefined>(undefined)
